// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventsPage_EventsPage__KWbFA {
  display: flex;
  justify-content: center;
  width: 100%;
}
.EventsPage_EventsPage__KWbFA .EventsPage_RightSide__sw1ys {
  padding: 20px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/EventsPage/EventsPage.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;EACA,WAAA;AACR","sourcesContent":[".EventsPage {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    .RightSide {\n        padding: 20px;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EventsPage": `EventsPage_EventsPage__KWbFA`,
	"RightSide": `EventsPage_RightSide__sw1ys`
};
export default ___CSS_LOADER_EXPORT___;
